import { toast } from 'sonner';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { t } from '@/i18n';
import { Mail } from 'lucide-react';
import { HelpTip } from '@/components/ui/help-tip';

// Report title with its schedule and the e-mail button. Sending needs a backend (ADR #11),
// so the demo only says the report is ready to be connected.
export const ReportHeader = ({ title, schedule, period }) => (
  <div className="flex flex-wrap items-start gap-3 border-b pb-3">
    <div className="min-w-0">
      <div className="text-sm font-semibold flex items-center gap-1">{title} <HelpTip id="reports" /></div>
      <div className="text-xs text-muted-foreground">{schedule} · {period}</div>
    </div>
    <div className="ml-auto flex items-center gap-2">
      <Badge variant="outline" className="text-[10px] whitespace-nowrap">{t('reports.readyToConnect')}</Badge>
      <Button variant="outline" size="sm" className="gap-1" onClick={() => toast.info(t('reports.sendToast'))}>
        <Mail className="h-3.5 w-3.5" /> {t('reports.send')}
      </Button>
    </div>
  </div>
);
